<template>
  <div class='no-visit'>
    <!-- 便民通 -->
    <img class='img-code' src="@/assets/img/gdems-code.png" alt='ems'>
    <div class='desc'>
      <p>请前往“邮政速递便民通”公众号使用</p>
    </div>
    <div class='prompt-msg'>
      <p >邮政速递便民通</p>
      <p>长按识别二维码关注</p>
    </div>
  </div>
</template>
<script>
export default {
}
</script>
<style lang='scss' scoped>
.no-visit {
  overflow: auto;
  height: 100vh;
  padding-bottom: torem(10px);
  background-color: #f9f9f9;
  text-align: center;
  padding-top:torem(10px);

  .img-code {
    width: 240px;
    height: 240px;
  }

  .prompt-msg {
    margin-top:torem(10px);
    p {
      color: #262626;
      font-size: torem(20px);
      font-weight: 500;
    }
  }

  .desc {
    color: #afafaf;
    font-size: torem(14px);
  }
}
</style>
